export default "__VITE_ASSET__CID55gbw__"